import React, { useEffect, useRef, useState } from "react";
import { User } from "~/common/Store/models/User";
import ReviewText from "./ReviewText";
import HelpfulReviewTotal from "./HelpfulReviewTotal";
import HelpfulReviewButtons from "./HelpfulReviewButtons";
import ExpertResponseComment from "./ExpertResponseComment";
interface Props {
  addUserUpvote: (reviewId: number, upvoted: boolean) => void;
  expertResponseComment: string;
  reviewId: number;
  reviewText: string;
  totalVotes: number;
  upvoteCount: number;
  user: User;
  userId: number;
  userUpvoted: boolean;
  userVoted: boolean;
}
const ScrollableReviewContent = ({
  addUserUpvote,
  expertResponseComment,
  reviewId,
  reviewText,
  totalVotes,
  upvoteCount,
  user,
  userId,
  userUpvoted,
  userVoted
}: Props) => {
  const [showReviewTextScrollbarPadding, setShowReviewTextScrollbarPadding] = useState(false);
  const reviewTextContainerRef = useRef<HTMLDivElement>(null);
  const reviewTextRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (reviewTextContainerRef.current && reviewTextRef.current) {
      setShowReviewTextScrollbarPadding(reviewTextContainerRef.current.scrollHeight > reviewTextContainerRef.current.clientHeight);
    }
  }, [reviewText]);
  return <div ref={reviewTextContainerRef} className={`flex-1 mt-4 overflow-visible md:overflow-y-auto md:overflow-x-hidden ${showReviewTextScrollbarPadding ? "pr-3" : ""}`} data-sentry-component="ScrollableReviewContent" data-sentry-source-file="ScrollableReviewContent.tsx">
      <div ref={reviewTextRef}>
        <ReviewText data-sentry-element="ReviewText" data-sentry-source-file="ScrollableReviewContent.tsx">{reviewText}</ReviewText>
      </div>
      <div className="flex flex-wrap items-center justify-between pt-2 gap-x-6 gap-y-4">
        {totalVotes > 0 && <HelpfulReviewTotal upvoteCount={upvoteCount} totalVotes={totalVotes} />}
        {user.registered && userId !== Number(user.index) && <HelpfulReviewButtons addUserUpvote={addUserUpvote} userVoted={userVoted} userUpvoted={userUpvoted} reviewId={reviewId} />}
      </div>
      {!!expertResponseComment && <ExpertResponseComment expertResponseComment={expertResponseComment} />}
    </div>;
};
export default ScrollableReviewContent;